import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { BUILD_VERSION, ENV_FIREBASE_CONFIG, INVISIBLE_CAPTCHA_ID } from 'src/environments/environment';
import { ContentfulService } from 'src/services/contentful.service';
import { SUPPORT_ROUTE_URLS, SHOP_ROUTE_URLS, ACCOUNT_ROUTE_URLS, ROUTE_URLS, PLANS_SHOP_ROUTE_URLS } from 'src/app/app.routes.names';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';
import { IUser } from '@ztarmobile/zwp-service-backend';
import { AppState } from 'src/app/app.service';
import { InvisibleRecaptchaComponent } from '@widgets/invisible-recaptcha/invisible-recaptcha.component';

@Component({
  selector: 'app-footer-main-navbar',
  templateUrl: 'footer-main-navbar.component.html',
  styleUrls: ['./footer-main-navbar.component.scss']
})
export class FooterMainNavbarComponent implements OnInit {
  @ViewChild('invisibleReCaptcha') invisibleReCaptcha: InvisibleRecaptchaComponent;

  public SITE_ID = INVISIBLE_CAPTCHA_ID;
  public autoExpandSubmenus = true;
  public BUILD_VERSION = BUILD_VERSION;
  public BUILD_DATE = new Date();
  public FIREBASE_CONF = ENV_FIREBASE_CONFIG;
  public ROUTE_URLS = ROUTE_URLS;
  public SHOP_ROUTE_URLS = SHOP_ROUTE_URLS;
  public ACCOUNT_ROUTE_URLS = ACCOUNT_ROUTE_URLS;
  public SUPPORT_ROUTE_URLS = SUPPORT_ROUTE_URLS;
  public PLANS_SHOP_ROUTE_URLS = PLANS_SHOP_ROUTE_URLS;
  public showAccount: boolean;
  public showShop: boolean;
  public showSupport: boolean;
  public showAbout: boolean;
  public innerWidth: any;
  public isLoggedIn = false;
  public userProfile: IUser;
  public displayAcpSection = false;
  public captchaResponse: string;
  public captchaValid = false;
  public isSeconCaptcha = false;
  public currentYear = new Date().getFullYear();

  private MOBILE_SCREEN_WIDTH = 1000;

  constructor(
    private contentful: ContentfulService,
    private simpleAuthService: SimpleAuthService,
    private appState: AppState) {
    // temp fix until i get the styles to flip the auto expanded flag based on resolution.
    if (window.screen.width <= this.MOBILE_SCREEN_WIDTH) {
      this.autoExpandSubmenus = false;
    }
  }
  ngOnInit(): void {
    this.simpleAuthService.userState.subscribe((authState) => {
      this.isLoggedIn = !!authState && !authState.isAnonymous;
    });
    this.appState.displayAcpSectionObs.subscribe(res => {
      this.displayAcpSection = res;
    });
    this.appState.resetAndExecuteCaptcha.subscribe(response => {
      if (!!response && response?.action) {
        this.invisibleReCaptcha.resetReCaptcha();
        this.invisibleReCaptcha.execute(response?.action);
        this.isSeconCaptcha = false;
      }
    });
    this.appState.resetAndExecuteSecondCaptcha.subscribe(response => {
      if (!!response && response?.action) {
        this.invisibleReCaptcha.resetReCaptcha();
        this.invisibleReCaptcha.execute(response?.action);
        this.isSeconCaptcha = true;
      }
    });
    this.innerWidth = window.innerWidth;
  }

  public resolvedCaptcha(captchaResponse: string): void {
    this.captchaResponse = captchaResponse;
    this.captchaValid = !!captchaResponse;
    if(!this.isSeconCaptcha) {
      this.appState.resolvedCaptchaSubject.next(captchaResponse);
    } else {
      this.appState.resolvedSecondCaptchaSubject.next(captchaResponse);
    }
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.innerWidth;
  }
}
